export default ({ request }) => ({
  techGoodsCuttingListApi(data = {}) {
    return request({
      url: '/factory/techGoodsCutting/list',
      method: 'post',
      data,
    })
  },
  techGoodsCuttingDetailApi(data = {}) {
    return request({
      url: '/factory/techGoodsCutting/detail',
      method: 'post',
      data,
    })
  },
  techGoodsCuttingDelApi(data = {}) {
    return request({
      url: '/factory/techGoodsCutting/del',
      method: 'post',
      data,
    })
  },
  techGoodsCuttingSaveApi(data = {}) {
    return request({
      url: '/factory/techGoodsCutting/save',
      method: 'post',
      data,
    })
  },

})
